import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { observer, useObserver } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { routeNode } from 'core/routing';

import { useRouterStore } from 'apps/hooks';

import { FourOhFour } from 'apps/fourOhFour';
import FullScreenLoading from 'apps/share/blocks/fullScreenLoading';

const UploadMakePart = lazy(() => import('apps/makePart/views/uploadMakePart'));
const MakePartFromFile = lazy(() =>
  import('apps/makePart/views/makePartFromFile'),
);

const viewsMap = {
  '': UploadMakePart,
  file: MakePartFromFile,
};

const MakePartSpace = withNamespaces()(
  observer(props => {
    const { route, params } = useRouterStore();
    const { componentFromRoute } = props;

    const View = componentFromRoute();

    return useObserver(() => (
      <Suspense fallback={<FullScreenLoading />}>
        <View params={params} routeName={route.name} />
      </Suspense>
    ));
  }),
);

MakePartSpace.propTypes = {
  routerStore: PropTypes.object,
  clientStore: PropTypes.object,
};

const MakePartRouter = routeNode(
  'make-part',
  viewsMap,
  FourOhFour,
)(MakePartSpace);

export default MakePartRouter;
